import { render, staticRenderFns } from "./EventCommentInput.vue?vue&type=template&id=335c5337&scoped=true&"
import script from "./EventCommentInput.vue?vue&type=script&lang=js&"
export * from "./EventCommentInput.vue?vue&type=script&lang=js&"
import style0 from "./EventCommentInput.vue?vue&type=style&index=0&id=335c5337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335c5337",
  null
  
)

export default component.exports